import React, { useState, useEffect } from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";
import getDate from "date-fns/getDate";
import addMonths from "date-fns/addMonths";
import { styled } from "styled-components";

import { ReactComponent as ChevronRight } from "../../assets/icons/chevron_right.svg";
import { addDays } from "date-fns";

const CustomHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    justify-content: center;
`;

const CustomHeaderInner = styled.div`
    display: flex;
    justify-content: center;
`;

const MonthNavButton = styled.button`
    display: flex;
    align-items: center;
    &:disabled {
        color: #adadbf;
    }
`;

const MonthWrapper = styled.div`
    font-size: 20px;
    font-weigth: 600;
    text-transform: uppercase;
    margin-left: 12px;
    margin-right: 12px;
`;

const Calendar = ({ onChange, dayClassName, weekDayClassName, dayContents, dateDisabled, monthToShown, containerClassName, customHeader, minBookingDate }) => {
    const [startDate, setStartDate] = useState(addDays(new Date(), parseInt(minBookingDate) || 0));
    const [disabledDate, setDisabledDate] = useState([]);

    useEffect(() => {
        disbledDateHandler();
    }, []);

    const setContainer = ({ className, children }) => {
        return <CalendarContainer className={`${className}`}>{children}</CalendarContainer>;
    };

    const renderCustomHeader = ({ monthDate, date, changeYear, changeMonth, customHeaderCount, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
        if (customHeader != undefined) {
            return customHeader(monthDate, date, changeYear, changeMonth, customHeaderCount, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled);
        }
        return (
            <CustomHeaderContainer>
                <CustomHeaderInner>
                    <MonthNavButton
                        type="button"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}>
                        <span className="material-symbols-outlined">chevron_left</span>
                    </MonthNavButton>
                    <MonthWrapper>
                        {monthDate.toLocaleString("en-US", {
                            month: "long",
                            year: "numeric",
                        })}
                    </MonthWrapper>
                    <MonthNavButton
                        type="button"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}>
                        {/* <span className="material-symbols-outlined">chevron_right</span> */}
                        <ChevronRight />
                    </MonthNavButton>
                </CustomHeaderInner>
            </CustomHeaderContainer>
        );
    };

    const renderDayContents = (day, date) => dayContents?.(date) || getDate(date);

    const dateClickHandler = (date) => {
        setStartDate(date);
        onChange?.(date) || console.log("DATE CLICKED");
    };

    const disbledDateHandler = () => {
        const disabledDateFromProps = dateDisabled?.() || [];
        setDisabledDate((prevDisabledDate) => [...prevDisabledDate, ...disabledDateFromProps]);
    };

    return (
        <DatePicker
            selected={startDate}
            onChange={dateClickHandler}
            minDate={addDays(new Date(), parseInt(minBookingDate) || 0)}
            maxDate={addMonths(new Date(), 11)}
            inline
            calendarContainer={setContainer}
            renderCustomHeader={renderCustomHeader}
            renderDayContents={renderDayContents}
            excludeDates={disabledDate}
            monthsShown={monthToShown || 1}
        />
    );
};

export default Calendar;
